export default {
  workspaceComments: [],
  user: [],
  meetingItem: [],
};
